import styled from "styled-components/macro";
import {useState} from "react";
import {TextButton} from "./button";

const Confirm = styled.span`
  font-weight: 500;
  color: red;
`;

const ConfirmButton = styled(function ConfirmButton({ onClick, ...props }) {
    const [confirm, setConfirm] = useState(false);
    const handleConfirm = () => {
        setConfirm(false);
        onClick();
    };
    return (
        confirm ? (
            <Confirm>
                {`Are you sure? `}
                <TextButton onClick={handleConfirm}>Yes</TextButton>
                { ` / `}
                <TextButton onClick={() => setConfirm(false)}>No</TextButton>
            </Confirm>
        ) : (
            <TextButton onClick={() => setConfirm(true)} {...props}/>
        )
    );
})``;

export default ConfirmButton;
